import styled from "styled-components"
import typography from "./typography"
import skColors from "../../styles/skColors"
import IntrinsicElements = React.JSX.IntrinsicElements
import { CSSProperties, ReactNode } from "react"

type Variant = keyof typeof typography.web
type TextProps = {
  variant: Variant
  as?: keyof IntrinsicElements
  color?: string
  children: ReactNode
  className?: string
  style?: CSSProperties
} & React.HTMLProps<HTMLSpanElement>
const variantToTag: Record<Variant, keyof IntrinsicElements> = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  pLarge: "p",
  pRegular: "p",
  pSmall: "p",
  cta: "span",
  captions: "span",
  tags: "span",
  unset: "span",
  ctaSmall: "span",
}

const Span = styled.span<TextProps>`
  font-size: ${({ variant }) => typography.web[variant].fontSize};
  line-height: ${({ variant }) => typography.web[variant].lineHeight};
  font-family: ${({ variant }) => typography.web[variant].fontFamily};
  font-weight: ${({ variant }) => typography.web[variant].fontWeight};
  letter-spacing: ${({ variant }) => typography.web[variant].letterSpacing};
  color: ${({ color }) => color || skColors.darkgreen["600"]};
  margin: 0;

  @media (max-width: 900px) {
    font-size: ${({ variant }) => typography.mobile[variant].fontSize};
    line-height: ${({ variant }) => typography.mobile[variant].lineHeight};
    font-family: ${({ variant }) => typography.mobile[variant].fontFamily};
    font-weight: ${({ variant }) => typography.mobile[variant].fontWeight};
    letter-spacing: ${({ variant }) => typography.mobile[variant].letterSpacing};
  }
`

const StyledText = (props: TextProps) => {
  const Component = props.as || variantToTag[props.variant] || "span"
  return (
    <Span style={props.style} className={props.className} as={Component} variant={props.variant} {...props}>
      {props.children}
    </Span>
  )
}

export default StyledText
